import React from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";

import { Outlet } from "react-router-dom";

const LicenceProfileDashboard: React.FC = ({ children }) => (
  <React.Fragment>
    <Helmet title="Authorisation Profile" />
    <Container fluid className="p-0">
      {children}
      <Outlet />
    </Container>
  </React.Fragment>
);

export default LicenceProfileDashboard;
